<template>
  <div>
    <div class="container col-2">
      <div class="row">
        <div class="col-md-12">
          <div id="main-banner" class="owl-carousel home-slider">
            <div class="item">
              <a href="#"
                ><img
                  src="../assets/image/banners/Main-Banner1.jpg"
                  alt="main-banner1"
                  class="img-responsive"
              /></a>
            </div>
            <div class="item">
              <a href="#"
                ><img
                  src="../assets/image/banners/Main-Banner2.jpg"
                  alt="main-banner2"
                  class="img-responsive"
              /></a>
            </div>
            <div class="item">
              <a href="#"
                ><img
                  src="../assets/image/banners/Main-Banner3.jpg"
                  alt="main-banner3"
                  class="img-responsive"
              /></a>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="cms_banner">
          <div class="col-md-4 cms-banner-left">
            <a href="#"
              ><img alt="#" src="../assets/image/banners/subbanner1.jpg"
            /></a>
          </div>
          <div class="col-md-4 cms-banner-middle">
            <a href="#"
              ><img alt="#" src="../assets/image/banners/subbanner2.jpg"
            /></a>
          </div>
          <div class="col-md-4 cms-banner-right">
            <a href="#"
              ><img alt="#" src="../assets/image/banners/subbanner3.jpg"
            /></a>
          </div>
        </div>
      </div>
      <div class="row">
        <div id="column-left" class="col-sm-3 hidden-xs column-left">
          <div class="column-block">
            <div class="columnblock-title">Categories</div>
            <div class="category_block">
              <ul class="box-category treeview-list treeview">
                <li><a href="#/category/electronics">Electronics</a></li>
                <li><a href="#/category/mobile">Mobile</a></li>
                <li><a href="#/category/fashion">Fashion</a></li>
                <li><a href="#/category/games">Games</a></li>
                <li><a href="#/category/sports">Sports</a></li>
              </ul>
            </div>
          </div>

          <div id="reco_box_1"></div>

          <div id="reco_box_2"></div>
        </div>
        <div id="content" class="col-sm-9">
          <div class="box">
            <div
              id="most-popular-products"
              class="row owl-carousel product-slider"
              ref="mostPopularProducts"
            ></div>
          </div>

          <div class="customtab">
            <div id="subbanner4" class="banner">
              <div class="item">
                <a href="#"
                  ><img
                    src="../assets/image/banners/subbanner4.jpg"
                    alt="Sub Banner4"
                    class="img-responsive"
                /></a>
              </div>
            </div>
            <div id="subbanner5" class="banner">
              <div class="item">
                <a href="#"
                  ><img
                    src="../assets/image/banners/subbanner5.jpg"
                    alt="Sub Banner5"
                    class="img-responsive"
                /></a>
              </div>
            </div>

            <div class="grid-list-wrapper">
              <div
                class="product-layout product-grid col-lg-3 col-md-4 col-sm-6 col-xs-12"
                v-for="(product, index) in getListProducts()"
                :key="index"
              >
                <div class="product-thumb">
                  <div class="image product-imageblock flex items-center">
                    <a :href="'#/product/' + product.id">
                      <img
                        :src="product.image"
                        :alt="product.name"
                        :title="product.name"
                        class="img-responsive"
                      />
                    </a>
                    <div class="button-group" style="display:none;">
                      <button type="button" class="addtocart-btn">
                        Add to Cart
                      </button>
                    </div>
                  </div>
                  <div class="caption product-detail">
                    <h4 class="product-name">
                      <a
                        :href="'#/product/' + product.id"
                        :title="product.name"
                      >
                        {{ $options.filters.limit(product.name, 53) }}
                      </a>
                    </h4>
                    <p class="product-desc">{{ product.desc }}</p>
                    <p class="price product-price">
                      <span class="price-old" v-if="product.oldPrice"
                        >${{ product.oldPrice }}</span
                      >
                      ${{ product.price }}
                      <span class="price-tax">Ex Tax: $100.00</span>
                    </p>
                  </div>
                  <div class="button-group">
                    <button
                      type="button"
                      class="wishlist"
                      data-toggle="tooltip"
                      title="Add to Wish List"
                    >
                      <i class="fa fa-heart-o"></i>
                    </button>
                    <button type="button" class="addtocart-btn">
                      Add to Cart
                    </button>
                    <button
                      type="button"
                      class="compare"
                      data-toggle="tooltip"
                      title="Compare this Product"
                    >
                      <i class="fa fa-exchange"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div id="recently-viewed-products"></div>

            <div class="blog">
              <div class="blog-heading">
                <h3>Latest Blogs</h3>
              </div>
              <div class="blog-inner box">
                <ul class="list-unstyled blog-wrapper" id="latest-blog">
                  <li class="item blog-slider-item">
                    <div class="panel-default">
                      <div class="blog-image">
                        <a href="#" class="blog-imagelink"
                          ><img src="../assets/image/blog/blog_1.jpg" alt="#"
                        /></a>
                        <span class="blog-hover"></span>
                        <span class="blog-date">06/07/2015</span>
                        <span class="blog-readmore-outer"
                          ><a href="#" class="blog-readmore">read more</a></span
                        >
                      </div>
                      <div class="blog-content">
                        <a href="#" class="blog-name">
                          <h2>Nunc rutrum scel potent</h2>
                        </a>
                        <div class="blog-desc">
                          Lorem ipsum doLorem ipsum dolor sit amet, consectetur
                          adipisicing elit, sed do eiusmod tempor incididunt ut
                          labore et dolore magna.Lorem ipsum doLorem ipsum dolor
                          sit amet, consectetur adipisicing...
                        </div>
                        <a href="#" class="blog-readmore">read more</a>
                        <span class="blog-date">06/07/2015</span>
                      </div>
                    </div>
                  </li>
                  <li class="item blog-slider-item">
                    <div class="panel-default">
                      <div class="blog-image">
                        <a href="#" class="blog-imagelink"
                          ><img src="../assets/image/blog/blog_2.jpg" alt="#"
                        /></a>
                        <span class="blog-hover"></span>
                        <span class="blog-date">06/07/2015</span>
                        <span class="blog-readmore-outer"
                          ><a href="#" class="blog-readmore">read more</a></span
                        >
                      </div>
                      <div class="blog-content">
                        <a href="#" class="blog-name">
                          <h2>Nunc rutrum scel potent</h2>
                        </a>
                        <div class="blog-desc">
                          Lorem ipsum doLorem ipsum dolor sit amet, consectetur
                          adipisicing elit, sed do eiusmod tempor incididunt ut
                          labore et dolore magna.Lorem ipsum doLorem ipsum dolor
                          sit amet, consectetur adipisicing...
                        </div>
                        <a href="singale-blog.html" class="blog-readmore"
                          >read more</a
                        >
                        <span class="blog-date">06/07/2015</span>
                      </div>
                    </div>
                  </li>
                  <li class="item blog-slider-item">
                    <div class="panel-default">
                      <div class="blog-image">
                        <a href="#" class="blog-imagelink"
                          ><img src="../assets/image/blog/blog_3.jpg" alt="#"
                        /></a>
                        <span class="blog-hover"></span>
                        <span class="blog-date">06/07/2015</span>
                        <span class="blog-readmore-outer"
                          ><a href="singale-blog.html" class="blog-readmore"
                            >read more</a
                          ></span
                        >
                      </div>
                      <div class="blog-content">
                        <a href="#" class="blog-name">
                          <h2>Nunc rutrum scel potent</h2>
                        </a>
                        <div class="blog-desc">
                          Lorem ipsum doLorem ipsum dolor sit amet, consectetur
                          adipisicing elit, sed do eiusmod tempor incididunt ut
                          labore et dolore magna.Lorem ipsum doLorem ipsum dolor
                          sit amet, consectetur adipisicing...
                        </div>
                        <a href="singale-blog.html" class="blog-readmore"
                          >read more</a
                        >
                        <span class="blog-date">06/07/2015</span>
                      </div>
                    </div>
                  </li>
                  <li class="item blog-slider-item">
                    <div class="panel-default">
                      <div class="blog-image">
                        <a href="#" class="blog-imagelink"
                          ><img src="../assets/image/blog/blog_4.jpg" alt="#"
                        /></a>
                        <span class="blog-hover"></span>
                        <span class="blog-date">06/07/2015</span>
                        <span class="blog-readmore-outer"
                          ><a href="#" class="blog-readmore">read more</a></span
                        >
                      </div>
                      <div class="blog-content">
                        <a href="#" class="blog-name">
                          <h2>Nunc rutrum scel potent</h2>
                        </a>
                        <div class="blog-desc">
                          Lorem ipsum doLorem ipsum dolor sit amet, consectetur
                          adipisicing elit, sed do eiusmod tempor incididunt ut
                          labore et dolore magna.Lorem ipsum doLorem ipsum dolor
                          sit amet, consectetur adipisicing...
                        </div>
                        <a href="#" class="blog-readmore">read more</a>
                        <span class="blog-date">06/07/2015</span>
                      </div>
                    </div>
                  </li>
                  <li class="item blog-slider-item">
                    <div class="panel-default">
                      <div class="blog-image">
                        <a href="#" class="blog-imagelink"
                          ><img src="../assets/image/blog/blog_5.jpg" alt="#"
                        /></a>
                        <span class="blog-hover"></span>
                        <span class="blog-date">06/07/2015</span>
                        <span class="blog-readmore-outer"
                          ><a href="#" class="blog-readmore">read more</a></span
                        >
                      </div>
                      <div class="blog-content">
                        <a href="#" class="blog-name">
                          <h2>Nunc rutrum scel potent</h2>
                        </a>
                        <div class="blog-desc">
                          Lorem ipsum doLorem ipsum dolor sit amet, consectetur
                          adipisicing elit, sed do eiusmod tempor incididunt ut
                          labore et dolore magna.Lorem ipsum doLorem ipsum dolor
                          sit amet, consectetur adipisicing...
                        </div>
                        <a href="#" class="blog-readmore">read more</a>
                        <span class="blog-date">06/07/2015</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div id="brand_carouse" class="owl-carousel brand-logo">
            <div class="item text-center">
              <a href="#"
                ><img
                  src="../assets/image/brand/brand1.png"
                  alt="Disney"
                  class="img-responsive"
              /></a>
            </div>
            <div class="item text-center">
              <a href="#"
                ><img
                  src="../assets/image/brand/brand2.png"
                  alt="Dell"
                  class="img-responsive"
              /></a>
            </div>
            <div class="item text-center">
              <a href="#"
                ><img
                  src="../assets/image/brand/brand3.png"
                  alt="Harley"
                  class="img-responsive"
              /></a>
            </div>
            <div class="item text-center">
              <a href="#"
                ><img
                  src="../assets/image/brand/brand4.png"
                  alt="Canon"
                  class="img-responsive"
              /></a>
            </div>
            <div class="item text-center">
              <a href="#"
                ><img
                  src="../assets/image/brand/brand5.png"
                  alt="Canon"
                  class="img-responsive"
              /></a>
            </div>
            <div class="item text-center">
              <a href="#"
                ><img
                  src="../assets/image/brand/brand6.png"
                  alt="Canon"
                  class="img-responsive"
              /></a>
            </div>
            <div class="item text-center">
              <a href="#"
                ><img
                  src="../assets/image/brand/brand7.png"
                  alt="Canon"
                  class="img-responsive"
              /></a>
            </div>
            <div class="item text-center">
              <a href="#"
                ><img
                  src="../assets/image/brand/brand8.png"
                  alt="Canon"
                  class="img-responsive"
              /></a>
            </div>
            <div class="item text-center">
              <a href="#"
                ><img
                  src="../assets/image/brand/brand9.png"
                  alt="Canon"
                  class="img-responsive"
              /></a>
            </div>
            <div class="item text-center">
              <a href="#"
                ><img
                  src="../assets/image/brand/brand5.png"
                  alt="Canon"
                  class="img-responsive"
              /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import productData from "../data/product.json";

export default {
  methods: {
    getListProducts() {
      return productData.product.slice(0, 12).sort(function() {
        return 0.5 - Math.random();
      });
    }
  },
  created() {

    var ck = localStorage.getItem('contact_key');
    if (ck) {
      dengage("setContactKey", ck);
    } else if (typeof ck == 'string') {
      dengage("setContactKey", '');
    }
    
    dengage("getContactKey", function(contact_key) {
      window.sgfLayer = {
        page: {
          pageUrl: "https://muhammed-wh.github.io",
          category: "Home Page"
        }
      };
      if (contact_key) {
        window.sgfLayer.common = {
          userId: contact_key
        };
      } else {
        dengage("getDeviceId", function(device_id) {
          window.sgfLayer.common = {
            userId: device_id
          };
        });
      }
    });

    this.$nextTick(() => {
      $("#main-banner,.gellery").owlCarousel({
        autoPlay: 5000,
        singleItem: true,
        navigation: false,
        navigationText: [
          '<i class="fa fa-chevron-left fa-5x"></i>',
          '<i class="fa fa-chevron-right fa-5x"></i>'
        ],
        pagination: true,
        transitionStyle: "fade"
      });

      $("#content #latest-blog").owlCarousel({
        items: 2,
        navigation: true,
        pagination: false,
        itemsDesktop: [1199, 2],
        itemsDesktopSmall: [979, 2],
        itemsTablet: [768, 2],
        itemsTabletSmall: false,
        itemsMobile: [479, 1]
      });

      $("#brand_carouse").owlCarousel({
        items: 5,
        navigation: true,
        pagination: false
      });
    });

    /*dengage("sendDeviceEvent", "user_events", {
      event_type: "page_view",
      page_url: window.location.href,
      page_type: "home",
      page_title: "Home Page"
    });*/
    /*dataLayer.push({
      event: 'dengage_event',
      dengage_table_name: 'user_events',
      dengage_event_data: {
        event_type: "page_view",
        page_url: window.location.href,
        page_type: "home",
        page_title: "Home Page"
      }
    });*/
    dengage("ec:pageView", {
      page_type: "home",
    });
    //collector.homePage(localStorage.getItem('contact_key'));
  },
  mounted() {
    dengage('setNavigation', {name: 'home'});
    $(this.$refs.mostPopularProducts).owlCarousel({
      items: 4,
      navigation: true,
      pagination: false,
      itemsDesktop: [1199, 3],
      itemsDesktopSmall: [979, 2],
      itemsTablet: [768, 2],
      itemsTabletSmall: false,
      itemsMobile: [479, 1]
    });

    $(this.$refs.featureSlider).owlCarousel({
      items: 4,
      navigation: true,
      pagination: false,
      itemsDesktop: [1199, 3],
      itemsDesktopSmall: [979, 2],
      itemsTablet: [768, 2],
      itemsTabletSmall: false,
      itemsMobile: [479, 1]
    });
  }
};
</script>

<style scoped>
.product-slider .product-thumb .product-imageblock,
#content .product-grid .product-thumb .product-imageblock,
#content .product-list .product-thumb .product-imageblock {
  width: 220px;
  height: 200px;
}
.product-thumb .image a {
  margin: 0 auto;
}
#content .product-grid .product-thumb .product-imageblock img,
#content .product-list .product-thumb .product-imageblock img {
  width: 135px;
  margin: 0 auto;
}
.product-thumb .product-name {
  min-height: 28px;
  max-height: 28px;
}
.product-list .product-thumb .caption {
  width: 72%;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue